import React from 'react';
import intl from 'react-intl-universal';
import PackActions from '../actions/PackActions';
import PackStore from '../stores/PackStore';
import AuthStore from '../stores/AuthStore';

class PackListItem extends React.Component {
  selectPack(e) {
    PackActions.selectPack({
      'id': parseInt(e.currentTarget.getAttribute('data-id')),
      'is_multi': e.currentTarget.getAttribute('data-multi') == '1',
      'important': e.currentTarget.getAttribute('data-important') == '1'
    })
  }

  render() {
    const { pack, wozek } = this.props
    return (
      <div onClick={this.selectPack}
           data-id={pack.id}
           data-multi={pack.is_multi?'1':'0'}
           data-important={pack.important?'1':'0'}
           data-company_id={pack.company_id}
           className="elem-tile">
        <h5>{pack.name}</h5>
        {intl.get('Data')}: {pack.time}<br/>
        {intl.get('Ilość zamówień')}: {pack.orders_left} / {pack.order_count}<br/>
        <span className={parseInt(pack.orders_with_error)>0?'text-red':''}>{intl.get('Błędy')}: {pack.orders_with_error}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span className={parseInt(pack.orders_with_product_shortages)>0?'text-red':''}>{intl.get('Braki')}: {pack.orders_with_product_shortages}</span>
        {pack.carrier_id &&
          <div>
            {intl.get('Kurier')}: {pack.carrier_id[1]}
          </div>
        }
        {wozek &&
          <div>
            {intl.get('Wózek')}: {pack.cart_id[1]}
          </div>
        }
      </div>
    );
  }
}

function getPackListItem(pack, wozek) {
  return (
    <PackListItem
      key={pack.id}
      pack={pack}
      wozek={wozek}
    />
  );
}

class PacksComponent extends React.Component {

  constructor() {
    super();
    this.state = {
      packs: [],
      config: AuthStore.getConfig()
    }
    this.onChange = this.onChange.bind(this);
  }

  componentWillMount() {
    PackStore.addChangeListener(this.onChange);
  }

  componentDidMount() {
    PackActions.recievePacks(AuthStore.getUser().id, AuthStore.getPakowalnia())
  }

  componentWillUnmount() {
    PackStore.removeChangeListener(this.onChange);
  }

  onChange() {
    this.setState({
      packs: PackStore.getPacks()
    });
  }

  render() {
    let packListItems;
    if (this.state.packs) {
      packListItems = this.state.packs.map(pack => getPackListItem(pack, this.state.config.wozek));
    }
    return (
      <div>
        <h1>
          <div className="breadcrumb">
              <span>{intl.get('Dostępne zamówienia na pakowalni')}:</span>
          </div>
        </h1>
        <div className="elem-list">
          {packListItems}
        </div>
      </div>
    );
  }
}

export default PacksComponent;



// WEBPACK FOOTER //
// ./src/components/Packs.js